import TabletopCanvasController from "./TabletopCanvasController";
import TabletopCanvasMouseEvent from "../events/TabletopCanvasMouseEvent";
import TabletopCanvasWheelEvent from "../events/TabletopCanvasWheelEvent";
import TabletopUniverse from "../../objects/TabletopUniverse";
import TabletopViewport from "../../objects/TabletopViewport";

export default class TabletopCanvasNavigationController extends TabletopCanvasController {
    public constructor(viewport: TabletopViewport, universe: TabletopUniverse) {
        super(viewport, universe);
    }

    public override dispose(): void {
        super.dispose();
    }

    public override onCanvasMouseDrag(e: TabletopCanvasMouseEvent): void {
        super.onCanvasMouseDrag(e);

        this._viewport.translate(
            -e.movement.x / this._viewport.magnificationX,
            -e.movement.y / this._viewport.magnificationY,
        );
    }

    public override onCanvasMouseWheel(e: TabletopCanvasWheelEvent): void {
        super.onCanvasMouseWheel(e);

        const scroll = e.deltaY;

        if (scroll > 0) {
            this._viewport.magnify(1 - 0.1, {
                x: e.viewportPosition.x,
                y: e.viewportPosition.y,
            });
        } else {
            this._viewport.magnify(1 + 0.1, {
                x: e.viewportPosition.x,
                y: e.viewportPosition.y,
            });
        }
    }
}
